import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Grid,
  IconButton,
  Typography,
  withWidth,
} from "@material-ui/core";
import TableChart from "@material-ui/icons/TableChart";
import MenuIcon from "@material-ui/icons/Menu";
import { connect } from "react-redux";

import { getRequiredDrawbacks } from "../../redux/selectors";
import Dialog from "../dialog";

const ApplicationBar = ({
  drawbacksRequired,
  handleHamburgerClick,
  drawerOpen,
  width,
}) => {
  const [openDialog, toggleDialog] = useState(false);

  return (
    <AppBar position="sticky" style={{ backgroundColor: "#FED2DF" }}>
      <Toolbar>
        <Grid container justify="space-between">
          <IconButton onClick={() => handleHamburgerClick(!drawerOpen)}>
            <MenuIcon />
          </IconButton>
          <IconButton
            onClick={() => toggleDialog(!openDialog)}
            style={{
              margin: ["lg", "xl"].includes(width) ? "0 0 0 64px" : "initial",
            }}
          >
            <TableChart />
          </IconButton>
          <Typography style={{ alignSelf: "center", color: "black" }}>
            {["lg", "xl"].includes(width) ? "Drawbacks Required: " : "DBs: "}
            {drawbacksRequired}
          </Typography>
        </Grid>
      </Toolbar>
      <Dialog open={openDialog} handleClose={() => toggleDialog(!openDialog)} />
    </AppBar>
  );
};

const mapStateToProps = (state) => ({
  drawbacksRequired: getRequiredDrawbacks(state),
});

export default connect(mapStateToProps)(withWidth()(ApplicationBar));
